module.exports = "/_next/static/images/ao-5bca990e0900e8eee99129acfecf1460.png";